import { axios } from "../axios";

const StatisticsService = {
    rentalFormEntered: ({
                         productCodeBase64,
                         shopUuid,
                         months = null,
                         ref = null
                     }) => async () => {
        return await axios
            .post(`/init/stats`, {
                productCodeBase64,
                shopUuid,
                months,
                ref
            })
            .then((res) => {
                return res.data;
            });
    },
};

export default StatisticsService;
